<template>

    <div v-if="showModal" @click.self="hide"
         class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center"
         style="background-color: rgba(0,0,0,.2);">
        <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

            <div class="rg-modal-header">
                <span>Set Default $ Value for Customer</span>

                <a href="javascript: void(0);" class="rg-modal-close-btn" @click="hide"><i class="mdi mdi-close"></i></a>
            </div>

            <div class="p-6" style="height: calc(100% - 110px); overflow: auto;">

                <!--                <div v-if="success" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4" role="alert">-->
                <!--                    {{success}}-->
                <!--                </div>-->

                <!--                <div v-if="error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">-->
                <!--                    <div v-html="error"></div>-->
                <!--                </div>-->

                <div class="flex flex-wrap">
                    <div class="w-full pr-5 mb-1 md:mb-0">
                        <p class="mb-1 text-xs mb-2"><strong>
                            $ Dollar Value *
                        </strong></p>
                        <input name="name" ref="val"
                               class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"
                               type="text">
                    </div>

                </div>
            </div>

            <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right"
                        :class="{'spinner': saving}">
                    Save
                </button>

                <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right"
                        @click="hide">
                    Cancel
                </button>

                <div class="clearfix"></div>

            </div>


        </div>
    </div>

</template>


<script>


export default {

    data: function () {
        return {
            showModal: false,
            saving: false,
            success: null,
            error: null,
            loginEnabled: false,
        }
    },

    methods: {
        show() {
            this.showModal = true
        },
        hide() {
            this.showModal = false
            this.saving = false
        },
    },

}
</script>


<style scoped>

</style>